import { Component } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { CardBodyComponent, CardComponent, ConfirmationService } from '@abp/ng.theme.shared';
import { CrudPage } from '@zendra/shared';
import { GetGisRegisterInconsistenciesInputDto, GisRegisterInconsistencyCase } from 'orchestrator';
import { GisRegisterInconsistencyBase } from '../gis-register-inconsistency/gis-register-inconsistency-base';
import { GISREGISTERINCONSISTENCYONLYINZENDRA_CONFIG, GISREGISTERINCONSISTENCYONLYINZENDRA_FIELDS } from './gis-register-inconsistency-only-in-zendra.config';

@Component({
  selector: 'lib-gis-register-inconsistency-only-in-zendra',
  imports: [CardComponent, CardBodyComponent, CrudPage],
  providers: [ListService, ConfirmationService],
  templateUrl: '../gis-stand-inconsistency/gis-stand-inconsistency.html',
})
export class GisRegisterInconsistencyOnlyInZendra extends GisRegisterInconsistencyBase {
  config = GISREGISTERINCONSISTENCYONLYINZENDRA_CONFIG;
  fields = GISREGISTERINCONSISTENCYONLYINZENDRA_FIELDS;

  protected override get caseFilter(): Partial<GetGisRegisterInconsistenciesInputDto> {
    return { case: GisRegisterInconsistencyCase.OnlyInZendra };
  }

  protected getEntityName(): string {
    return 'GisRegisterInconsistencyOnlyInZendra';
  }
}
